import { FeatureFlagContextProps, withFeatureFlagContext } from "@app/feature-flags";
import { DropdownItem, MultiselectDropdown } from "@app/shared/checkbox-dropdown";
import classNames from "classnames";
import { startCase } from "lodash";
import { Component } from "react";
import { AccuracyProviderClaimsActivityLabelEnum } from "../../../projects/enumerators";

type AccuracyPcaFilterProps = FeatureFlagContextProps & {
  onPcaChange: (pcaLabel: number) => void;
  onPcaChangeDropdown: (selections: DropdownItem<number>[]) => void;
  pcaIds: number[];
}

class WrappedAccuracyPcaFilter extends Component<AccuracyPcaFilterProps> {
  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">Provider Claims Activity Filter</p>
        <p className="mb-1">Please select the provider claims activity volume to include:</p>
        {this.renderAccuracyPcaFilter()}
      </>
    );
  }

  private renderAccuracyPcaFilter() {
    const pcaItems: DropdownItem<number>[] = [];
    const selectedItems: DropdownItem<number>[] = [];
    let selectText = "";
    Object.values(AccuracyProviderClaimsActivityLabelEnum).forEach((v, i) => {
      const item = {
        key: i,
        name: startCase(v),
      };
      pcaItems.push(item)
      if (this.props.pcaIds.indexOf(i) > -1) {
        selectedItems.push(item);
      }
    });
    selectText = `${selectedItems.length} of ${pcaItems.length} options selected`;

    return (
      <div className="form-group row" >
        <label className="col-12 col-form-label ptb0 text-left">Include</label>
        <div className={classNames("col-12 col-xl-10 col-lg-9 mt0")}>
          <MultiselectDropdown
            label="Provider Claims Activity Filter"
            hideLabel={true}
            containerClassName="w-100"
            customSelectInputText={selectText}
            items={pcaItems}
            selectedItems={selectedItems}
            testId="accuracy-pca-filter__dropdown"
            onSelectionChanged={(selections) => this.props.onPcaChangeDropdown(selections)}
          />
        </div>
      </div>
    );
  }
}

const AccuracyPcaFilter = withFeatureFlagContext(WrappedAccuracyPcaFilter);
export default AccuracyPcaFilter;
